import { render } from "./MultifileElement.vue?vue&type=template&id=23d2677c"
import script from "./MultifileElement.vue?vue&type=script&lang=js"
export * from "./MultifileElement.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/kl_keepjoy_work/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__